import { render, staticRenderFns } from "./ProtocolDetail.vue?vue&type=template&id=6a6e8326&"
import script from "./ProtocolDetail.vue?vue&type=script&lang=js&"
export * from "./ProtocolDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports